import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface RequireAuthProps {
  children: React.ReactNode;
}

export const RequireAuth: React.FC<RequireAuthProps> = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) {
    // Редиректим на страницу авторизации с сохранением текущего пути
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};